<template>
  <v-row justify="center">
    <v-dialog v-model="showModal" persistent max-width="800px">
      <v-card :loading="loading" :disabled="cardDisabled">
        <v-card-title>
          <span class="headline">{{ $t("New Study") }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-alert
              text
              prominent
              dismissible
              v-model="alertShow"
              type="error"
              icon="mdi-alert"
              >{{ alertText }}</v-alert
            >
            <v-form ref="form">
              <v-row>
                <v-col class="column-border" cols="12">
                  <v-textarea
                    outlined
                    name="input-7-4"
                    ref="dicomJson"
                    v-model="dicomJson"
                    :auto-grow="autoGrow"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="darken-1" text @click="hide">{{ $t("close") }}</v-btn>
          <v-btn color="darken-1" text @click="addStudy">{{
            $t("save")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from "axios";
//import i18n from "../../i18n";
import EventBus from "../../event-bus";

export default {
  name: "NewStudyModal",
  props: {},
  data: () => ({
    showModal: false,
    loading: false,
    autoGrow: true,
    cardDisabled: false,
    errorMessages: [],
    alertText: null,
    alertShow: false,
    dicomJson: null,
    dummyJsonx: JSON.stringify(
      {
        accessionNumber: "MEME",
        patientName: "LOREM^IPSUM",
        patientId: "3141592653",
        patientBirthDate: "20000101",
        patientSex: "M",
        studyInstanceUid: "3141592",
        scheduledProcedureStepSequence: {
          modality: "OT",
          scheduledStationAeTitle: "PROTEUS",
          scheduledProcedureStepStartDate: "20200101",
        },
        requestedProcedureId: "R31415926",
        expireAfter: 1000,
      },
      null,
      2
    ),
  }),
  methods: {
    random(max, min) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    today() {
      function pl(n) {
        return ("00" + n).slice(-2);
      }

      let date = new Date();
      return date.getFullYear() + pl(date.getMonth() + 1) + pl(date.getDate());
    },
    dummyJson() {
      return JSON.stringify(
        {
          accessionNumber: "X" + String(this.random(9999999, 1000000)),
          patientName: "LOREM^IPSUM^" + this.random(99, 10),
          patientId: String(this.random(9999999, 1000000)),
          patientBirthDate: "20000101",
          patientSex: "M",
          studyInstanceUid: String(this.random(99999, 10000)),
          scheduledProcedureStepSequence: {
            modality: "MR",
            scheduledStationAeTitle: "PROTEUS",
            scheduledProcedureStepStartDate: this.today(),
          },
          requestedProcedureId: "X" + String(this.random(9999999, 1000000)),
          expireAfter: 1000,
        },
        null,
        2
      );
    },
    sendErrorAndCloseModal(error) {
      if (error.response) {
        if (
          error.response.status == 400 &&
          error.response.data.status == "error"
        ) {
          EventBus.$emit("SHOW_ERROR", error.response.data.error);
        } else {
          EventBus.$emit("SHOW_ERROR", error.response.data);
        }
      } else {
        EventBus.$emit("SHOW_ERROR", error);
      }

      this.loading = false;
      this.showModal = false;
    },
    sendErrorOnModal(error) {
      if (error.response) {
        if (
          error.response.status == 400 &&
          error.response.data.status == "error"
        ) {
          this.alertText = error.response.data.error;
        } else {
          this.alertText = error.response.data;
        }
      } else {
        this.alertText = error;
      }

      this.loading = false;
      this.alertShow = true;
    },
    show() {
      this.alertShow = false;
      this.alertText = "";
      this.dicomJson = this.dummyJson();
      this.showModal = true;
      setTimeout(() => {
        let textarea = this.$refs.dicomJson.$el.querySelector("textarea");
        textarea.onfocus = function () {
          textarea.setSelectionRange(0, 0);
        };
      });
    },
    addStudy() {
      this.alertShow = false;
      this.alertText = "";
      let newDicomJson = {};
      let textarea = this.$refs.dicomJson.$el.querySelector("textarea");

      try {
        newDicomJson = JSON.parse(this.dicomJson);
      } catch (err) {
        let jsonerror = JSON.stringify(err.message);
        this.sendErrorOnModal(jsonerror);
        if (jsonerror.indexOf("position") > -1) {
          // Highlight error position
          var positionStr = jsonerror.lastIndexOf("position") + 8;
          var posi = parseInt(
            jsonerror.substr(positionStr, jsonerror.lastIndexOf('"'))
          );
          if (posi >= 0) {
            textarea.onfocus = function () {
              textarea.setSelectionRange(posi, posi + 1);
            };
            textarea.focus();
          }
        }
        return;
      }

      // Remove range selection.
      textarea.onfocus = function () {
        textarea.setSelectionRange(0, 0);
      };

      this.loading = true;

      axios({
        url: "/api/v1/worklist/study",
        headers: { "Content-Type": "application/json" },
        data: newDicomJson,
        method: "POST",
      })
        .then((response) => {
          this.loading = false;

          if (
            !response.data ||
            !response.data.status ||
            !(response.data.status == "done")
          ) {
            this.sendErrorOnModal(response);
          } else {
            this.$parent.$parent.updateTable();
            this.hide();
          }
        })
        .catch((error) => {
          this.sendErrorOnModal(error);
        });
    },
    hide() {
      this.showModal = false;
    },
  },
};
</script>

<style>
.v-alert {
  overflow: hidden;
}

.disable-events {
  pointer-events: none;
}

.outlinedButton {
  padding: 4px !important;
}

.jv-item {
  color: black !important;
}

.jv-key {
  font-weight: bold;
}

.jv-code {
  padding-top: 0px !important;
}

.borderless-column {
  padding: 0px !important;
}

.column-border {
  margin: 12px;
  border: 1px;
  border-style: solid;
  max-width: 97% !important;
}

::-moz-selection {
  color: white;
  background-color: black;
}
::selection {
  color: white;
  background-color: black;
}
</style>